var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_507",
    "data-name": "\\uADF8\\uB8F9 507",
    transform: "translate(-2707.606 -5722.582) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_57",
    "data-name": "\\uC0AC\\uAC01\\uD615 57",
    width: 24,
    height: 24,
    transform: "translate(-5746.582 2707.606)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_58",
    "data-name": "\\uC0AC\\uAC01\\uD615 58",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(-5746.582 2707.606)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M-5740.337,2717.507l5.755,4.791,5.755-4.791",
    fill: "none",
    stroke: "#292424",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.54af377d0c37f90157c72b50c16052aa.svg";
export { ForwardRef as ReactComponent };